module.exports = __webpack_public_path__ + "static/media/m_y_25.8f02566d.png";